const integrations = [
  {
    text: "API",
    pci: 2,
  },
  {
    text: "Magento 2.3",
    pci: 2,
  },
  {
    text: "PagBrasil.JS",
    pci: 1,
  },
  {
    text: "iFrame",
    pci: 0,
  },
  {
    text: "Link de Pagamento",
    pci: 0,
  },
  {
    text: "Shopify App",
    pci: 0,
  },
  {
    text: "Salesforce",
    pci: 0,
  },
  {
    text: "WooCommerce",
    pci: 0,
  },
  {
    text: "Prestashop",
    pci: 0,
  },
  {
    text: "VTEX",
    pci: 0,
  },
];

export default integrations;
